import { TaskReadable } from '@crm/api'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { stringifyUrl } from '@crm/utils'
import { Text } from '@shared/components'
import {
  DEFAULT_ISO_DATE_FORMAT,
  format,
  today,
  tomorrow,
  yesterday
} from '@shared/utils'
import { Flex } from 'antd'

import { useStyles } from './styles'
import { TaskType } from './types'

type Props = {
  data?: TaskReadable
  taskType: TaskType
}
const TaskItem = ({ data, taskType }: Props) => {
  const { title, priority, type: typeId, owner, created_by } = data ?? {}

  const { styles } = useStyles({
    type: taskType,
    priority: priority ?? 1
  })

  const navigate = useAppNavigate()

  const deadlineQueryMap: Record<TaskType, Record<string, string>> = {
    expired: {
      deadline: 'custom',
      deadline_end: format(yesterday, DEFAULT_ISO_DATE_FORMAT)
    },
    future: {
      deadline: 'custom',
      deadline_start: format(tomorrow, DEFAULT_ISO_DATE_FORMAT)
    },
    current: {
      deadline: 'today',
      deadline_end: format(today, DEFAULT_ISO_DATE_FORMAT),
      deadline_start: format(today, DEFAULT_ISO_DATE_FORMAT)
    }
  }

  const onOpenTasks = () => {
    const baseQuery = {
      ...deadlineQueryMap[taskType],
      ...(typeId && { type: typeId }),
      ...(owner && { owner }),
      ...(created_by && { created_by })
    }

    navigate(stringifyUrl(paths.tasks.root, baseQuery))
  }

  return (
    <Flex justify="center" align="start" gap={8} className="w-full">
      <div className={styles.priority} />

      <Text
        isEllipsis
        className="w-full pointer"
        color="colorLink"
        onClick={onOpenTasks}
      >
        {title}
      </Text>
    </Flex>
  )
}

export default TaskItem
